import {Dispatch} from '@reduxjs/toolkit'
import {NavigateFunction} from 'react-router-dom'
import {setNewPasswordModalOpen} from 'entities/app'
import {LinkAction, ModalName, RedirectLinkData} from 'entities/app/types'
import {FindMeKeys, setSearchFilters, TabKeys} from 'entities/searchPeople'
import {REDIRECT_LINK_LOCAL_STORAGE_KEY} from 'shared/mirrors/config'

export const RedirectLinkHandler = (dispatch: Dispatch, navigate: NavigateFunction) => {
  const link = localStorage.getItem(REDIRECT_LINK_LOCAL_STORAGE_KEY)
  if (!link) return

  try {
    const data = JSON.parse(link) as RedirectLinkData
    if (!data) return
    const {action, modal} = data

    switch (action.name) {
    case LinkAction.SEARCH:

      if (!action.params) break
      const {params} = action

      dispatch(setSearchFilters({
        ageFrom: params.ageFrom as string,
        ageTo: params.ageTo as string,
        continents: params.continents as string,
        findMe: (params.gender as FindMeKeys) || FindMeKeys.female,
        tab: params.type as TabKeys
      }))

      navigate('/people')
    }

    switch (modal.name) {
    case ModalName.RESET_PASSWORD:
      dispatch(setNewPasswordModalOpen(true))
      break
    }
  } catch (e) {
    console.error(e)
  } finally {
    localStorage.removeItem(REDIRECT_LINK_LOCAL_STORAGE_KEY)
  }
}